var _rect, _path, _path2, _path3, _circle, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMonitoring = function SvgMonitoring(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 54,
    viewBox: "0 0 58 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 36,
    height: 28,
    rx: 1,
    fill: "#C7DFF2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.001 0H3.00098C1.34413 0 0.000976562 1.34316 0.000976562 3V35C0.000976562 36.6568 1.34413 38 3.00098 38H29.001V36H3.00098C2.4487 36 2.00095 35.5523 2.00095 35V3C2.00095 2.44772 2.4487 1.99997 3.00098 1.99997H43.001C43.5533 1.99997 44.001 2.44772 44.001 3V25H46.001V3C46.001 1.34316 44.6579 0 43.001 0Z",
    fill: "#413D45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 36.9999H16V42.9999H18V36.9999Z",
    fill: "#413D45"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 36.9999H28V42.9999H30V36.9999Z",
    fill: "#413D45"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 31,
    r: 10,
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5475 23.182C42.5097 21.1438 39.7457 19.9989 36.8636 19.999C30.8631 19.9992 25.9988 24.8638 25.999 30.8644C25.9993 36.865 30.8639 41.7292 36.8645 41.729C39.7456 41.7289 42.5086 40.5845 44.5461 38.5474C48.7895 34.3047 48.7901 27.4255 44.5475 23.182ZM36.8585 39.73C31.9625 39.7283 27.9948 35.758 27.9965 30.862C27.9981 25.966 31.9685 21.9983 36.8645 22C39.2177 21.9936 41.4755 22.93 43.1334 24.5999C44.7945 26.2629 45.7272 28.5175 45.7265 30.868C45.7248 35.764 41.7545 39.7317 36.8585 39.73Z",
    fill: "#413D45"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7073 45.5L49.4303 39.225C49.2428 39.0375 48.9885 38.932 48.7233 38.932C48.4581 38.9321 48.2039 39.0375 48.0164 39.225L45.2264 42.015C44.836 42.4054 44.836 43.0384 45.2264 43.429L51.5034 49.707C51.6909 49.8946 51.9453 50 52.2104 50C52.476 49.9991 52.7304 49.8926 52.9173 49.704L55.7073 46.914C56.0977 46.5234 56.0977 45.8904 55.7073 45.5ZM52.2103 47.586L47.3473 42.7219L48.7232 41.346L53.5863 46.21L52.2103 47.586Z",
    fill: "#413D45"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.547 37.1322L43.1328 38.5464L46.6202 42.0338L48.0344 40.6196L44.547 37.1322Z",
    fill: "#413D45"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37 24V26C39.7601 26.0032 41.9967 28.2399 42 30.9999H43.9999C43.9956 27.1358 40.8642 24.0044 37 24Z",
    fill: "#413D45"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32 42.0001H14V44H32V42.0001Z",
    fill: "#413D45"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16 12C14.3432 12 13 13.3432 13 15C13 16.6568 14.3432 18 16 18C17.6568 18 19 16.6568 19 15C19 13.3432 17.6568 12 16 12ZM16 15.9999C15.4477 15.9999 15 15.5522 15 14.9999C15 14.4476 15.4477 13.9999 16 13.9999C16.5523 13.9999 17 14.4476 17 14.9999C17 15.5523 16.5523 15.9999 16 15.9999Z",
    fill: "#413D45"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23 19C21.3432 19 20 20.3432 20 22C20 23.6568 21.3432 25 23 25C24.6568 25 26 23.6568 26 22C26 20.3432 24.6568 19 23 19ZM23 23C22.4477 23 22 22.5523 22 22C22 21.4477 22.4477 21 23 21C23.5523 21 24 21.4477 24 22C23.9999 22.5523 23.5523 23 23 23Z",
    fill: "#413D45"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2929 15.2926L9.29297 20.2925L10.7071 21.7067L15.7071 16.7068L14.2929 15.2926Z",
    fill: "#413D45"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7023 15.2959L16.2881 16.7101L21.288 21.71L22.7022 20.2958L17.7023 15.2959Z",
    fill: "#413D45"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M30 12C28.3432 12 27 13.3432 27 15C27 16.6568 28.3432 18 30 18C31.6568 18 33 16.6568 33 15C33.0001 13.3432 31.6569 12 30 12ZM30 15.9999C29.4477 15.9999 29 15.5522 29 14.9999C29 14.4476 29.4477 13.9999 30 13.9999C30.5523 13.9999 31 14.4476 31 14.9999C31 15.5523 30.5523 15.9999 30 15.9999Z",
    fill: "#413D45"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2919 15.2961L23.292 20.296L24.7062 21.7101L29.7061 16.7102L28.2919 15.2961Z",
    fill: "#413D45"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMonitoring);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/monitoring.16d6f13bcfc93b81ecdebb2a5371cd2a.svg";